import React from 'react';
import { useTheme } from '@mui/material/styles';
import { Box, Grid, useMediaQuery } from '@mui/material';
import Slider from 'react-slick';

import { SimTypography } from 'components/SimTypography';
import { SimButton } from 'components/SimButton';
import RefDiagram from 'assets/images/childDiagnosticsHarvardPaper.png';

const SimHero = props => {
	const theme = useTheme();
	const isMd = useMediaQuery(theme.breakpoints.up('md'), {
		defaultMatches: true
	});

	const words = ['Autism', "Asperger's", 'ADHD', 'Stunted Growth', 'Speech delay'];

	const sliderOpts = {
		dots: false,
		arrows: false,
		infinite: true,
		slidesToShow: isMd ? 1 : 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 2000,
		fade: true
	};

	const LeftSide = () => (
		<Box data-aos={isMd ? 'fade-right' : 'fade-up'}>
			<Box marginTop={{ xs: 4, sm: 4, md: 4, lg: 4 }} display={'flex'}>
				<SimTypography
					variant='h3'
					// fontSize={{ xs: 30, md: 45 }}
					color={theme.palette.text.headerLight}
					sx={{ fontWeight: 500 }}>
					{props.topTitle}
					<div>{props.bottomTitle}</div>
					<Box
						width={{ xs: '80vw', sm: '60vw', md: 450 }}
						height={{ xs: '10vw', sm: '10vw', md: '5vw' }}
						bgcolor={'transparent'}
						margin={0}
						padding={0}>
						<Slider {...sliderOpts}>
							{words.map((item, i) => (
								<Box key={i} margin={0} padding={0}>
									<Box
										display={'block'}
										width={1}
										margin={0}
										padding={0}
										height={1}
										sx={{
											textDecoration: 'none',
											transition: 'all .2s ease-in-out'
										}}>
										<SimTypography
											color={theme.palette.secondary.mainOrange}
											variant={'h3'}
											sx={{
												fontWeight: 400
											}}>
											{item}
										</SimTypography>
									</Box>
								</Box>
							))}
						</Slider>
					</Box>
				</SimTypography>
			</Box>

			<Box marginBottom={{ xs: 2, sm: 2, md: 2, lg: 2 }} display={'flex'} justifyContent={'flex-end'}>
				<SimButton
					variant={'contained'}
					backgroundColor={theme.palette.secondary.main}
					color={theme.palette.primary.main}
					size={'large'}
					href={'/contact'}>
					Start screening
				</SimButton>
			</Box>

			<Box>
				<SimTypography variant='h6' color={theme.palette.text.bodyLight}>
					{props.topContent}
				</SimTypography>
				<SimTypography variant='h6' color={theme.palette.text.bodyLight}>
					{props.content}
				</SimTypography>
			</Box>

			<Box
				display='flex'
				width={1}
				flexDirection={{ xs: 'column', sm: 'row' }}
				justifyContent={'left'}
				alignItems={{ xs: 'center', sm: 'flex-end' }}
				paddingTop={{ xs: 3, sm: 2, md: 1 }}
				paddingBottom={5}>
				<Box margin={0.5}>
					<SimButton
						variant={'contained'}
						backgroundColor={theme.palette.secondary.main}
						color={theme.palette.primary.main}
						size={'large'}
						href={'/contact'}>
						{props.firstBtnText}
					</SimButton>
				</Box>

				{props.secondBtnText && (
					<Box margin={0.5}>
						<SimButton
							variant={'contained'}
							backgroundColor={theme.palette.secondary.main}
							color={theme.palette.primary.main}
							size={'large'}
							href={'/contact'}>
							{props.secondBtnText}
						</SimButton>
					</Box>
				)}

				{props.thirdBtnText && (
					<Box margin={0.5}>
						<SimButton
							variant={'contained'}
							backgroundColor={theme.palette.secondary.main}
							color={theme.palette.primary.main}
							size={'large'}
							href={'/contact'}>
							{props.thirdBtnText}
						</SimButton>
					</Box>
				)}
			</Box>
		</Box>
	);

	return (
		<Grid container spacing={4} paddingBottom={-4} marginBottom={0}>
			<Grid item container alignItems={'center'} xs={12} md={6.5}>
				<Box data-aos={isMd ? 'fade-right' : 'fade-up'}>
					<LeftSide />
				</Box>
			</Grid>

			<Grid
				item
				container
				alignItems={'center'}
				justifyContent={{ xs: 'center', sm: 'center', md: 'flex-end' }}
				xs={12}
				md={5.5}
				data-aos='flip-left'
				data-aos-easing='ease-out-cubic'
				data-aos-duration='2000'
				zIndex={2}
				marginTop={{ xs: 0, sm: 0, md: 25 }}>
				<Box
					component={'img'}
					border={0}
					borderRadius={3}
					boxShadow={3}
					borderColor={theme.palette.primary.main}
					loading='lazy'
					src={RefDiagram}
					alt='...'
					width={{ xs: '80vw', md: '35vw' }}
				/>
			</Grid>
		</Grid>
	);
};

export default SimHero;
